import moment from 'moment'
import { IDS_TREND_BY_PORT } from './constant'

const PERIOD_TYPE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
}

const covertToMMMYYYY = (month, year) => {
  return moment(`${month}/${year}`, 'MM/YYYY').format('MMM-YYYY')
}

export const getMonthAndYearInDataRange = (data, type = PERIOD_TYPE.YEARLY) => {
  return data
    .map((item) => ({
      month: item?.month,
      year: item?.year,
      quarter: item?.quarter,
    }))
    ?.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t) =>
          type === PERIOD_TYPE.MONTHLY
            ? t.month === value.month && t.year === value.year
            : type === PERIOD_TYPE.QUARTERLY
            ? t.quarter === value.quarter && t.year === value.year
            : t.year === value.year,
        ),
    )
    .sort((a, b) => {
      if (a.year === b.year) {
        if (type === PERIOD_TYPE.MONTHLY) {
          if (a.month < b.month) return -1
        }
        if (type === PERIOD_TYPE.QUARTERLY) {
          if (a.quarter < b.quarter) return -1
        }
        return 0
      } else {
        if (a.year < b.year) return -1
      }
      return 0
    })
}

export const getColumnKey = (data, type, isTable = false) => {
  const key = getMonthAndYearInDataRange(data, type)

  return key.map((value) => {
    return data.filter((item) =>
      type === PERIOD_TYPE.MONTHLY
        ? item.month === value.month && item.year === value.year
        : type === PERIOD_TYPE.YEARLY
        ? item.year === value.year
        : item.quarter === value.quarter && item.year === value.year,
    )
  })
}

export const convertDataChart = (data, type) => {
  const dataKeyColumn = getColumnKey(data, type)

  const dataReal = dataKeyColumn.map((item) => {
    let obj = {}
    item.forEach((key) => {
      obj[`description${key.showInterQuartile}`] = key?.quarTileName
      obj[`portfolioName${key.showInterQuartile}`] = key?.portfolioName
      obj['ticker'] =
        type === PERIOD_TYPE.YEARLY
          ? key.year
          : type === PERIOD_TYPE.MONTHLY
          ? covertToMMMYYYY(key?.month, key.year)
          : `Q${key.quarter}-${key.year}`
      obj[`data${key.showInterQuartile}`] = key.medianValue
      obj['year'] = key.year
      obj['month'] = key?.month
      obj[`dataFloatBar${key.showInterQuartile}`] = [
        key?.quartile1,
        key?.quartile3,
      ]
    })
    return obj
  })

  return dataReal
}

export const getColumnTable = (data, type) => {
  const key = getMonthAndYearInDataRange(data, type)
  return key.map((item) =>
    type === PERIOD_TYPE.YEARLY
      ? item?.year
      : type === PERIOD_TYPE.MONTHLY
      ? covertToMMMYYYY(item?.month, item?.year)
      : `Q${item?.quarter}-${item?.year}`,
  )
}

const getDataRowTable = (data, id, type) => {
  const keyByTime = getMonthAndYearInDataRange(data, type)
  const obj = {}
  const dataById = data.filter((key) => key.showInterQuartile === id)
  keyByTime.forEach((item) => {
    if (type === PERIOD_TYPE.YEARLY) {
      obj[item?.year] = {
        ...obj[item?.year],
        ...dataById.find((key) => key?.year === item?.year),
      }
    }
    if (type === PERIOD_TYPE.MONTHLY) {
      obj[covertToMMMYYYY(item?.month, item?.year)] = {
        ...obj[covertToMMMYYYY(item?.month, item?.year)],
        ...dataById.find(
          (key) => key?.year === item?.year && key?.month === item?.month,
        ),
      }
    }
    if (type === PERIOD_TYPE.QUARTERLY) {
      obj[`Q${item?.quarter}-${item?.year}`] = {
        ...obj[`Q${item?.quarter}-${item?.year}`],
        ...dataById.find(
          (key) => key?.year === item?.year && key?.quarter === item?.quarter,
        ),
      }
    }
  })
  return obj
}

export const convertDataTable = (data, type) => {
  const obj = {}
  Object.values(IDS_TREND_BY_PORT).forEach((id) => {
    obj[id] = {
      name: id,
      ...getDataRowTable(data, id, type),
    }
  })
  return obj
}

export const handleGetIdsCheckDynamic = (
  portfolio1,
  portfolio2,
  listCheckType,
) => {
  const arrPort = [
    portfolio1?.isChecked ? 4 : undefined,
    portfolio2?.isChecked ? 5 : undefined,
  ]

  const arrType = []

  listCheckType.forEach((item) => {
    switch (item) {
      case 'Filtered portfolio':
        arrType.push(1)
        break
      case 'Lowest current score portfolio':
        arrType.push(3)
        break
      case 'Largest decline score in recent years':
        arrType.push(2)
        break
      default:
        break
    }
  })

  return [...arrType, ...arrPort].filter(Boolean)
}

export const convertDataCheckBox = (data) => data.map((item) => `data${item}`)
